import { Component, OnInit } from '@angular/core';
import { User } from '../user';
import { UserService } from '../user.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Router} from '@angular/router';
import { Location } from '@angular/common';
import { UtilityService } from  '../../utility.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {


  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  user = new User();  
  users: User[];
  submitted = false;
	message: string;	
	  totalrecord:number;
  userFilter: any = { username: '' };
  userdata : any = {}
  public ResetPassword = "none"
  public selectedUserID;
  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private util:UtilityService
  ) { }

  ngOnInit() {
    this.getUsers();
  }

  getUsers() {
    return this.userService.getUsers()
               .subscribe(
                users => {
                  console.log(users);
                  this.users = users;
				          this.totalrecord = this.users.length;
                 }
                );
 }


  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

OpenResetPassword(userID){
  this.selectedUserID = userID
  this.ResetPassword='block'; 
 }

 closeResetPassword(){
  this.ResetPassword='none'; 
}

OnResetPassword(userid){
   return this.userService.ResetPassword(userid)
   .subscribe(
    users => {
      this.closeResetPassword();
      this.util.showSuccess("Reset password successfully.") 
     }
    );
  }
}
